import { useCallback, useEffect, useState } from 'react';
import { listLogisticsProviders } from '@/modules/logistics/services';
import type { LogisticsProvider } from '@/modules/logistics/types';

export function useLogisticsProviders() {
  const [providers, setProviders] = useState<LogisticsProvider[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setProviders(await listLogisticsProviders());
    } catch {
      setError('No se pudieron cargar los proveedores.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { providers, loading, error, refresh };
}
